import { render, staticRenderFns } from "./PodSecurityAdmission.vue?vue&type=template&id=6ee4a494&"
import script from "./PodSecurityAdmission.vue?vue&type=script&lang=ts&"
export * from "./PodSecurityAdmission.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports